export default __webpack_public_path__ + "static/media/indi.82a273f8.jpg";